import { render } from "./HwAside.vue?vue&type=template&id=a2989474&scoped=true"
import script from "./HwAside.vue?vue&type=script&lang=js"
export * from "./HwAside.vue?vue&type=script&lang=js"

import "./HwAside.vue?vue&type=style&index=0&id=a2989474&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2989474"]])

export default __exports__